import React, { useMemo, useState, useEffect } from 'react';
import { Flex, Input, Typography } from 'antd';
import FacetDropdown from '../../Products/Discovery/Filters/FacetDropdown';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import { setWorkflowFilters, selectWorkflowFilters } from '../../../store/workflows/slice';
import { FilterDTOType } from '../../../schemas';
import { MagnifyingGlassIcon, SpinnerGapIcon } from '@phosphor-icons/react';
import { useSearchWorkflowsInfiniteQuery } from '../../../store/workflows/workflowApi';

const STATUS_OPTIONS = [
  { id: 'RUNNING', value: 'Running' },
  { id: 'PAUSED', value: 'Paused' },
  { id: 'STOPPED', value: 'Stopped' },
];

const SCHEDULE_TYPE_OPTIONS = [
  { id: 'ONE_TIME', value: 'One Time' },
  { id: 'ONGOING', value: 'Ongoing' },
  { id: 'SCHEDULED', value: 'Scheduled' },
];

function toFilters(
  status: Array<string>,
  scheduleType: Array<string>,
  name: string,
): Array<FilterDTOType> {
  const filters: Array<FilterDTOType> = [];
  if (status.length > 0) {
    filters.push({
      field: 'status',
      filterType: status.length === 1 ? 'EQ' : 'IN',
      value: status.join(','),
    });
  }
  if (scheduleType.length > 0) {
    filters.push({
      field: 'scheduleType',
      filterType: scheduleType.length === 1 ? 'EQ' : 'IN',
      value: scheduleType.join(','),
    });
  }
  if (name && name.trim()) {
    filters.push({
      field: 'name',
      filterType: 'ICONTAINS',
      value: name.trim(),
    });
  }
  return filters;
}

const Discovery = () => {
  const dispatch = useAppDispatch();
  const filters = useAppSelector(selectWorkflowFilters);

  const { isLoading, isFetching, status: qstatus } = useSearchWorkflowsInfiniteQuery({ filters });

  const status = useMemo(
    () => filters.find(f => f.field === 'status')?.value?.split(',') ?? [],
    [filters],
  );
  const scheduleType = useMemo(
    () => filters.find(f => f.field === 'scheduleType')?.value?.split(',') ?? [],
    [filters],
  );
  const name = useMemo(() => filters.find(f => f.field === 'name')?.value ?? '', [filters]);

  const [inputName, setInputName] = useState(name);

  useEffect(() => {
    setInputName(name);
  }, [name]);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (inputName !== name) {
        dispatch(setWorkflowFilters(toFilters(status, scheduleType, inputName)));
      }
    }, 400);

    return () => clearTimeout(handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputName]);

  const handleStatusChange = (vals: Array<string>) => {
    dispatch(setWorkflowFilters(toFilters(vals, scheduleType, inputName)));
  };
  const handleScheduleTypeChange = (vals: Array<string>) => {
    dispatch(setWorkflowFilters(toFilters(status, vals, inputName)));
  };
  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputName(e.target.value);
  };

  return (
    <Flex vertical gap={16} style={{ width: '100%' }} align="flex-start">
      <Input
        placeholder="Search by Name"
        value={inputName}
        onChange={handleNameChange}
        suffix={
          isFetching ? (
            <SpinnerGapIcon className="anticon-spin" style={{ color: '#bfbfbf' }} />
          ) : (
            <MagnifyingGlassIcon style={{ color: '#bfbfbf' }} />
          )
        }
        allowClear
        style={{
          maxWidth: 320,
          borderRadius: 20,
        }}
      />

      <Flex
        vertical
        align="flex-start"
        style={{
          background: '#ffffff',
          borderRadius: 20,
          padding: 24,
          width: '100%',
        }}
      >
        <Typography.Paragraph strong={true}>Workflow Filters</Typography.Paragraph>

        <Flex gap={24}>
          <FacetDropdown
            facet={{
              key: { key: 'status', displayName: 'Status' },
              values: STATUS_OPTIONS,
            }}
            selectedValues={status}
            onChange={handleStatusChange}
            size="middle"
          />
          {/* <FacetDropdown
            facet={{
              key: { key: 'scheduleType', displayName: 'Schedule Type' },
              values: SCHEDULE_TYPE_OPTIONS,
            }}
            selectedValues={scheduleType}
            onChange={handleScheduleTypeChange}
            size="middle"
          /> */}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Discovery;
